import { render, staticRenderFns } from "./workCalendar.vue?vue&type=template&id=70c6a1ce&scoped=true"
import script from "./workCalendar.vue?vue&type=script&lang=js"
export * from "./workCalendar.vue?vue&type=script&lang=js"
import style0 from "./workCalendar.vue?vue&type=style&index=0&id=70c6a1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c6a1ce",
  null
  
)

export default component.exports